/**
 * 确定性随机数。
 *
 * 铁律：世界必须是「同一个 seed + 同一个时刻 → 完全一致的画面」，
 * 所以整条链路上不允许出现 Math.random()。所有随机都从这里派生。
 */

/** 把任意字符串折成一个 32 位无符号整数（FNV-1a）。 */
export function hashString(str: string): number {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

/** 把两个整数混成一个 32 位种子（用于 "seed + index" 派生）。 */
export function hash2(a: number, b: number): number {
  let h = Math.imul(a ^ 0x9e3779b9, 0x85ebca6b) ^ Math.imul(b + 0x165667b1, 0xc2b2ae35);
  h ^= h >>> 15;
  h = Math.imul(h, 0x2545f491);
  h ^= h >>> 13;
  return h >>> 0;
}

/** splitmix32：小而快，输出 [0,1)。同一个 seed 永远给出同一串数字。 */
export function splitmix32(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x9e3779b9) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** 便捷封装：在 [min,max) 上取值。 */
export function range(rand: () => number, min: number, max: number): number {
  return min + (max - min) * rand();
}

/** 房码 → 世界种子。6 位房码、两端算出同一个 seed。 */
export function seedFromRoomCode(code: string): number {
  return hashString(`sea-duet:${code.toUpperCase()}`);
}
